module.exports = __webpack_public_path__ + "img/header-hand.e236962b.png";